import React from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';

require('../../css/components/AssignmentSlat.scss');

'use strict';

export default class AssignmentLink extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var assignment = this.props.assignment;
        var title = this.props.title;

        var urlHash = this.props.urlHash || "";

        urlHash = queryString.parse(urlHash);
        urlHash["assignmentId"] = assignment.id;
        urlHash = queryString.stringify(urlHash);

        var url = this.props.url + (urlHash ? ("#" + urlHash) : "");

        return (
            <Link to={url} style={{ flexGrow: "1" }}>
                <span className={this.props.className || ""}>{title || assignment.titleDx[this.props.languageCode] || assignment.titleDx["eng"]}</span>
            </Link>
        );
    }
}